/** @format */

import apiSlice from './api-slice';

export const bookingScheduleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBookingSchedules: builder.query({
      query: (params) => ({
        url: `/booking/schedule/list`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingSchedule']
    }),

    getAllBookingScheduleWaitingConfirm: builder.query({
      query: (params) => ({
        url: `/booking/schedule/listWaitingConfirm`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingSchedule']
    }),
    getCarBookingSchedules: builder.query({
      query: ({ carId, ...params }) => ({
        url: `/booking/schedule/listByCar/${carId}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingSchedule']
    }),

    getBookingSchedule: builder.query({
      query: ({ id, ...params }) => ({
        url: `/booking/schedule/${id}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingSchedule']
    }),

    nhaxeCreateBookingSchedule: builder.mutation({
      query: (params) => ({
        url: '/booking/schedule/nhaxe',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['BookingSchedule']
    }),
    updateBookingSchedule: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/schedule/${id}`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingSchedule', 'Car', 'CarCheckAvailableBSchedule']
    }),

    updateWithoutEffectBookingSchedule: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/schedule/${id}`,
          method: 'PATCH',
          body: params
        };
      }
    }),

    updateBookingSchedules: builder.mutation({
      query: (params) => {
        return {
          url: `/booking/schedule/all`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingSchedule', 'Car']
    }),

    updateWithoutEffectBookingSchedules: builder.mutation({
      query: (params) => {
        return {
          url: `/booking/schedule/all`,
          method: 'PATCH',
          body: params
        };
      }
    }),

    confirmBookingSchedule: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/schedule/${id}/confirm`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingSchedule', 'Driver', 'Car']
    }),
    deleteBookingSchedule: builder.mutation({
      query: (id) => {
        return {
          url: `/booking/schedule/${id}`,
          method: 'DELETE'
        };
      },
      invalidatesTags: ['BookingSchedule']
    })
  })
});

export const {
  useGetBookingSchedulesQuery,
  useGetCarBookingSchedulesQuery,
  useGetBookingScheduleQuery,
  useNhaxeCreateBookingScheduleMutation,
  useUpdateBookingScheduleMutation,
  useUpdateBookingSchedulesMutation,
  useUpdateWithoutEffectBookingSchedulesMutation,
  useDeleteBookingScheduleMutation,
  useConfirmBookingScheduleMutation,
  useGetAllBookingScheduleWaitingConfirmQuery
} = bookingScheduleApi;
